<p-dialog [header]="dialogHeader" [(visible)]="displayDialog" [closable]="true" (onHide)="closeDialog()" [modal]="true"
    [style]="{width: '40vw'}" appendTo="body" [focusOnShow]="false">
    <form [formGroup]="detailsForm" novalidate>

        <div *ngIf="fromDashboard" class="p-grid">
            <div class="p-col-12">
                <label>Workspace <span style="color: red;">*</span></label>
                <p-dropdown [options]="worspaceList" (onChange)="onWorkspaceChange()"
                    [(ngModel)]="selectedWorkspaceId"
                    [ngModelOptions]="{standalone: true}"
                    [filter]="true"
                    appendTo="body"
                    placeholder="Select Workspace"
                    optionLabel="name"
                    optionValue="id">
                </p-dropdown>
            </div>

            <div class="p-col-12">
                <label>Workbook <span style="color: red;">*</span></label>
                <p-dropdown [options]="workBookList" (onChange)="onWorkbookChange()"
                    [(ngModel)]="selectedWorkbookId"
                    [ngModelOptions]="{standalone: true}"
                    [filter]="true"
                    appendTo="body"
                    placeholder="Select Workbook"
                    optionLabel="name"
                    optionValue="id">
                </p-dropdown>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <label>Chart Title <span style="color: red;">*</span></label>
                <input type="text" formControlName="title" pInputText placeholder="Chart Title" class="p-inputtext p-component p-filled p-fluid">
                <div *ngIf="detailsFormErrors?.title" class="p-invalid p-mb-1">
                    <small>{{ detailsFormErrors?.title }}</small>
                </div>
            </div>

            <div class="p-col-12">
                <label>Chart Type <span style="color: red;">*</span></label>
                <p-dropdown [options]="chartTypes" (onChange)="onSelectChartType($event)" formControlName="type" appendTo="body" placeholder="Select Chart Type"
                    optionLabel="name" styleClass="p-fluid">
                </p-dropdown>
                <div *ngIf="detailsFormErrors?.type" class="p-invalid p-mb-1">
                    <small>{{ detailsFormErrors?.type }}</small>
                </div>
            </div>

            <!-- Columns Fields -->
            <ng-container *ngIf="selectedChartType && columnsForm">
                <ng-container formGroupName="columns">
                    <ng-container *ngFor="let field of selectedChartType.fields">
                        <div class="p-col-12 p-mt-2">
                            <div class="p-d-flex p-ai-center p-mb-2">
                               <span>{{ field.label }} <span style="color: red;">*</span></span>
                               <div *ngIf="field.type === 'multiselect' && field.showOperation" class="p-ml-auto">
                                    <button pButton type="button" label="Add Field" icon="pi pi-plus" class="p-button-sm"
                                    (click)="openFieldSelectionDialog(field)"></button>
                                </div>
                            </div>

                            <!-- Standard dropdown field -->
                            <ng-container *ngIf="field.type === 'dropdown'">
                                <p-dropdown [options]="getFilteredColumns(field)" [formControlName]="field.name" appendTo="body"
                                    placeholder="Select Column" optionLabel="name" styleClass="p-fluid">
                                </p-dropdown>
                                <!-- Operation for dropdown when showOperation is true -->
                                <ng-container *ngIf="field.showOperation && columnsForm.get(field.name).value">
                                    <div class="p-mt-3">
                                        <label>Operation (Optional)</label>
                                        <p-dropdown [options]="operations"
                                            [formControl]="columnOperationsForm.get(getOperationControlName(field.name, columnsForm.get(field.name).value))"
                                            appendTo="body"
                                            placeholder="Select Operation (Optional)"
                                            optionLabel="name"
                                            optionValue="code"
                                            [showClear]="true"
                                            styleClass="p-fluid">
                                        </p-dropdown>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <!-- Multiselect field with direct field selection -->
                            <ng-container *ngIf="field.type === 'multiselect'">
                                <!-- Display standard multiselect field if showOperation is false -->
                                <ng-container *ngIf="!field.showOperation">
                                    <p-multiSelect [options]="getFilteredColumns(field)" [formControlName]="field.name"
                                        defaultLabel="Select Columns" optionLabel="name" styleClass="p-fluid" appendTo="body">
                                    </p-multiSelect>
                                </ng-container>

                                <!-- For multiselect with showOperation, use dialog for field selection and table for display -->
                                <ng-container *ngIf="field.showOperation">

                                    <!-- Display selected fields with operations in a table -->
                                    <div *ngIf="getSelectedColumns(field.name).length === 0" class="p-message p-message-info p-mb-2">
                                        <div class="p-message-wrapper">
                                            <span class="p-message-text">No fields selected</span>
                                        </div>
                                    </div>

                                    <p-table [value]="getSelectedColumns(field.name)" *ngIf="getSelectedColumns(field.name).length > 0"
                                        styleClass="p-datatable-sm" [tableStyle]="{'min-width': '100%'}">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>Field</th>
                                                <th>Operation</th>
                                                <th style="width: 4rem"></th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-column>
                                            <tr>
                                                <td>{{ column.name }}</td>
                                                <td>{{ getOperationDisplayName(columnOperationsForm.get(getOperationControlName(field.name, column)).value) }}</td>
                                                <td>
                                                    <button pButton pRipple type="button" icon="pi pi-trash"
                                                        class="p-button-text"
                                                        (click)="removeColumnField(field.name, column)"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                            </ng-container>

                            <div *ngIf="getColumnError(field.name)" class="p-invalid p-mb-1">
                                <small>Please select {{ field.label.toLowerCase() }}</small>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" (click)="closeDialog()" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="submitForm()"></button>
    </ng-template>
</p-dialog>

<!-- Field selection dialog -->
<p-dialog header="Add Field" [(visible)]="showFieldSelectionDialog"
    [style]="{width: '30rem'}" [modal]="true" appendTo="body">
    <div class="p-grid" *ngIf="currentEditingField">
        <div class="p-col-12 p-mb-2">
            <label>Select Field <span style="color: red;">*</span></label>
            <p-dropdown [options]="getAvailableColumnsForField(currentEditingField)"
                [(ngModel)]="selectedFieldWithOperation.field"
                appendTo="body"
                placeholder="Select Field"
                optionLabel="name"
                styleClass="p-fluid">
            </p-dropdown>
        </div>
        <div class="p-col-12 p-mb-2">
            <label>Operation (Optional)</label>
            <p-dropdown [options]="operations"
                [(ngModel)]="selectedFieldWithOperation.operation"
                appendTo="body"
                placeholder="Select Operation"
                optionLabel="name"
                optionValue="code"
                [showClear]="true"
                [disabled]="!selectedFieldWithOperation.field"
                styleClass="p-fluid">
            </p-dropdown>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-secondary" (click)="closeFieldSelectionDialog()"></button>
        <button pButton pRipple label="Add" icon="pi pi-check" [disabled]="!selectedFieldWithOperation.field" (click)="addFieldWithOperation()"></button>
    </ng-template>
</p-dialog>
